// ============================================================================
// note-client-mod -- useNotebooks Hook
//
// 获取当前用户的笔记本列表（含 noteCount）。
// ============================================================================
import { useState, useEffect, useCallback } from 'react';
import { getNoteApiClient } from '../note-api-client.js';
export function useNotebooks() {
    const [notebooks, setNotebooks] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const fetchNotebooks = useCallback(async () => {
        setLoading(true);
        setError(null);
        try {
            const result = await getNoteApiClient().getNotebooks();
            setNotebooks(result);
        }
        catch (err) {
            setError(err instanceof Error ? err.message : '获取笔记本失败');
            setNotebooks([]);
        }
        finally {
            setLoading(false);
        }
    }, []);
    useEffect(() => {
        fetchNotebooks();
    }, [fetchNotebooks]);
    return { notebooks, loading, error, refresh: fetchNotebooks };
}
//# sourceMappingURL=use-notebooks.js.map